export default "__VITE_ASSET__ae2ab52a__"